import { OrganizationActivityState } from "@idw-types/state/organization-activity-state";
import { OrganizationActivityActionTypes, OrganizationActivityActions } from "../actions/organization-activity-actions";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";

export const initialOrganizationActivityState: OrganizationActivityState = {
    searchFilters: {
        companyId: null,
        startDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).startDate,
        endDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).endDate,
        timeRangeType: TimeRangeTypes.CURRENT_MONTH
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        activityLogs: null
    }
};

export const organizationActivityReducer = (
    state: OrganizationActivityState = initialOrganizationActivityState,
    action: OrganizationActivityActions
): OrganizationActivityState => {
    switch (action.type) {
        // Search
        case OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialOrganizationActivityState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationActivityActionTypes.SET_ORGANIZATION_ACTIVITY_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    activityLogs: action.payload.activityLogs,
                    searchDate: new Date()
                }
            };
        default:
            return state;
    }
};